import { t } from "i18next";

const Copyright = () => {
  return (
    <div className="container-fluid copyright py-4">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            &copy; <a className="fw-medium" href="#">{t('company_name')}</a> {t('all_rights_reserved')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Copyright;